import { render, staticRenderFns } from "./vue-magnifier.vue?vue&type=template&id=8be4d84e"
import script from "./vue-magnifier.vue?vue&type=script&lang=js"
export * from "./vue-magnifier.vue?vue&type=script&lang=js"
import style0 from "./vue-magnifier.vue?vue&type=style&index=0&id=8be4d84e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports